// @core/api/endpoints/form/get_form_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormPolicyResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Get entity form policy
 * Returns the form policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolveFormContext for that.
 */
export async function GetFormPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<FormPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<FormPolicyResponse>(requestPath, { ...requestOptions });
}
